function getFocusableElements(e) {
    return Array.from(e.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"))
}

const desktopQuery = window.matchMedia("(min-width: 750px)");
document.querySelectorAll('[id^="Details-"] summary').forEach((e => {
    e.setAttribute("role", "button");
    e.setAttribute("aria-expanded", e.parentNode.hasAttribute("open"));
    if (e.nextElementSibling.getAttribute("id")) {
        e.setAttribute("aria-controls", e.nextElementSibling.id)
    }
    e.addEventListener("click", (e => {
        e.currentTarget.setAttribute("aria-expanded", !e.currentTarget.closest("details").hasAttribute("open"))
    }));
    if (e.closest("header-drawer")) return;
    if (e.closest(".footer__accordion")) {
        const t = e => {
            e.setAttribute("aria-expanded", false);
            e.parentNode.removeAttribute("open")
        };
        const i = e => {
            e.setAttribute("aria-expanded", true);
            e.parentNode.setAttribute("open", "")
        };
        if (desktopQuery.matches) {
            i(e)
        } else {
            t(e)
        }
        const s = s => {
            if (s.matches) {
                i(e)
            } else {
                t(e)
            }
        };
        if (typeof desktopQuery?.addEventListener === "function") {
            desktopQuery.addEventListener("change", s)
        } else {
            desktopQuery.addListener(s)
        }
    }
    if (e.closest(".accordion-with-image")) {
        const t = e.closest(".collapsible-with-images");
        const i = t.querySelector(".collapsible-with-images__image-wrapper");
        const s = i.querySelectorAll(".collapsible-with-images__media");
        const n = t.querySelectorAll("summary");
        n.forEach(((e, i) => {
            e.addEventListener("click", (() => {
                s.forEach(((e, t) => {
                    if (t === i) {
                        e.classList.remove("is-hidden")
                    } else {
                        e.classList.add("is-hidden")
                    }
                }));
                const e = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height"), 10);
                const n = t.getBoundingClientRect().top + window.pageYOffset - e - 60;
                window.scrollTo({top: n, behavior: "smooth"})
            }))
        }))
    }
    if (e.closest(".product__option-accordion")) {
        document.addEventListener("click", (t => {
            if (!e.contains(t.target)) {
                e.setAttribute("aria-expanded", false);
                e.parentNode.removeAttribute("open")
            }
        }))
    }
    const t = document.querySelector("#header__login-popup-close");
    if (t) {
        t.addEventListener("click", (() => {
            e.setAttribute("aria-expanded", false);
            e.parentNode.removeAttribute("open")
        }))
    }
    if (e.closest(".header__login-popup")) {
        const t = e.parentElement;
        document.addEventListener("click", (i => {
            if (!t.contains(i.target)) {
                e.setAttribute("aria-expanded", false);
                e.parentNode.removeAttribute("open")
            }
        }))
    }
    if (e.closest(".accordion--close-others")) {
        const t = document.querySelectorAll(".accordion--close-others");
        t.forEach((t => {
            const i = t.querySelectorAll("summary");
            e.addEventListener("click", (t => {
                const s = t.target.closest("summary");
                const n = s.parentElement.querySelector(".accordion__content");
                setTimeout((() => {
                    n.classList.add("animate")
                }), 10);
                i.forEach((e => {
                    if (e !== s) {
                        e.setAttribute("aria-expanded", false);
                        e.parentNode.removeAttribute("open");
                        e.parentElement.querySelector(".accordion__content").classList.remove("animate")
                    }
                }));
                if (e.parentElement.classList.contains("accordion-with-image")) return;
                if (e.closest(".accordion--close-others").classList.contains("product__measure-accordion")) return;
                const r = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height"), 10);
                const o = e.getBoundingClientRect().top + window.pageYOffset - r - 60;
                window.scrollTo({top: o, behavior: "smooth"})
            }))
        }))
    }
    e.parentElement.addEventListener("keyup", onKeyUpEscape)
}));

// Desktop hover for mega menu
if (window.matchMedia("(min-width: 990px)").matches) {
  const megaMenus = document.querySelectorAll(".mega-menu");
  let activeMenu = null;
  let activeContent = null;

  // Ensure all closed on load
  megaMenus.forEach((menu) => {
    const content = menu.querySelector(".mega-menu__content");
    menu.removeAttribute("open");
    if (content) {
      content.style.display = "none";
      content.style.opacity = "0";
      content.style.transform = "none"; // avoid leftover y transforms
    }
    const menuItem = menu.querySelector(".header__menu-item");
    if (menuItem) menuItem.setAttribute("aria-expanded", "false");
  });

  function setMenuTextColors(openMenu) {
    megaMenus.forEach((m) => {
      const t = m.querySelector(".header_menu-item-text");
      if (!t) return;
      if (openMenu && m !== openMenu) {
        t.style.color = "#acabab";
      } else {
        t.style.color = "#201B1B";
      }
      t.style.transition = "color 0.2s ease-in-out";
    });
  }

function hardCloseMenu(menu, { animate = true } = {}) {
if (!menu) return;

const content = menu.querySelector(".mega-menu__content");
const menuItem = menu.querySelector(".header__menu-item");

const finalize = () => {
    menu.removeAttribute("open");
    if (content) {
    content.style.display = "none";
    content.style.opacity = "0";
    content.style.transform = "none";
    content.style.clipPath = "none";
    }
    if (menuItem) menuItem.setAttribute("aria-expanded", "false");
};

if (!content) return finalize();

// ✅ During tab switching we don't want the close mask at all
if (!animate || typeof gsap === "undefined") return finalize();

gsap.killTweensOf(content);
content.style.display = "block";
content.style.opacity = "1";

gsap.to(content, {
    clipPath: "inset(0 0 100% 0)",
    duration: 0.4,
    ease: "cubic-bezier(0.42, 0, 0.58, 1)",
    onComplete: () => {
    finalize();
    gsap.set(content, { clearProps: "clipPath" });
    },
});
}



function openMenu(menu) {
const content = menu.querySelector(".mega-menu__content");
if (!content) return;

content.style.clipPath = "none";

if (!activeMenu) {
    menu.setAttribute("open", "");
    content.style.display = "block";

    if (content && typeof gsap !== 'undefined') {
    content.style.display = 'block';

    // Start "masked" (hidden from bottom) and reveal to full
    gsap.killTweensOf(content);

    gsap.fromTo(
        content,
        {
        opacity: 1,
        clipPath: 'inset(0 0 100% 0)',
        },
        {
        clipPath: 'inset(0 0 0% 0)',
        duration: 0.4,
        ease: 'cubic-bezier(0.42, 0, 0.58, 1)',
        clearProps: 'clipPath',
        }
    );
    } else if (content) {
    content.style.display = 'block';
    }


    const menuItem = menu.querySelector(".header__menu-item");
    if (menuItem) menuItem.setAttribute("aria-expanded", "true");
    setMenuTextColors(menu);

    activeMenu = menu;
    activeContent = content;
    return;
}

// If hovering the same menu again, do nothing
if (menu === activeMenu) return;

const prevMenu = activeMenu;
const prevContent = activeContent;

menu.setAttribute("open", "");
content.style.display = "block";
content.style.opacity = "0";
content.style.transform = "none";

const prevItem = prevMenu.querySelector(".header__menu-item");
if (prevItem) prevItem.setAttribute("aria-expanded", "false");

const nextItem = menu.querySelector(".header__menu-item");
if (nextItem) nextItem.setAttribute("aria-expanded", "true");

setMenuTextColors(menu);

if (typeof gsap !== "undefined") {
    gsap.killTweensOf(prevContent);
    gsap.killTweensOf(content);

    gsap.to(prevContent, {
    opacity: 0,
    duration: 0.12,
    ease: "cubic-bezier(0.42, 0, 0.58, 1)",
    onComplete: () => {
        hardCloseMenu(prevMenu, { animate: false });
    },
    });

    gsap.to(content, {
    opacity: 1,
    duration: 0.12,
    ease: "cubic-bezier(0.42, 0, 0.58, 1)",
    });
} else {
    prevContent.style.opacity = "0";
    hardCloseMenu(prevMenu);
    content.style.opacity = "1";
}

activeMenu = menu;
activeContent = content;
}

megaMenus.forEach((menu) => {
  const menuItem = menu.querySelector(".header__menu-item");
  if (!menuItem) return;

  menuItem.addEventListener("mouseenter", () => openMenu(menu));
});

function closeAllOpenMenus() {
  hardCloseMenu(activeMenu);
  activeMenu = null;
  activeContent = null;
  setMenuTextColors(null);
}

// Close menus when mouse enters header icons area
const headerIcons = document.querySelector(".header__icons");
if (headerIcons) headerIcons.addEventListener("mouseenter", closeAllOpenMenus);

// Close menus when mouse enters notification bar area
const notificationBar = document.querySelector(".notification-bar");
if (notificationBar) notificationBar.addEventListener("mouseenter", closeAllOpenMenus);

// Close menus when mouse enters main content area
const mainContent = document.querySelector("#MainContent");
if (mainContent) mainContent.addEventListener("mouseenter", closeAllOpenMenus);

let closeOnScrollRaf = null;
window.addEventListener(
"scroll",
() => {
    if (closeOnScrollRaf) return;
    closeOnScrollRaf = window.requestAnimationFrame(() => {
    closeOnScrollRaf = null;
    closeAllOpenMenus();
    });
},
{ passive: true }
);
}

// Tree menu title click navigation
document.querySelectorAll('.tree-menu-summary, .tree-submenu-summary').forEach(summary => {
  const title = summary.querySelector('.tree-menu-title');
  if (title && summary.dataset.url) {
    title.style.cursor = 'pointer';
    title.addEventListener('click', (e) => {
      e.stopPropagation();
      window.location.href = summary.dataset.url;
    });
  }
});

// Mobile click for mega menu
if (window.matchMedia('(max-width: 989px)').matches) {
  const megaMenus = document.querySelectorAll('.mega-menu');
  
  // Open first menu by default on mobile
  if (megaMenus.length > 0) {
    const firstMenu = megaMenus[0];
    firstMenu.classList.add('open');
    const firstContent = firstMenu.querySelector('.mega-menu__content');
    if (firstContent) {
      firstContent.style.display = 'block';
    }
  }
  
  // Add click handlers for mobile
  megaMenus.forEach(menu => {
    const menuItem = menu.querySelector('.header__menu-item');
    
    if (menuItem) {
      menuItem.addEventListener('click', () => {
        const isOpen = menu.classList.contains('open');
        const content = menu.querySelector('.mega-menu__content');
        if (!isOpen && content) {
          // Close all other menus
          megaMenus.forEach(m => {
            if (m !== menu) {
              m.classList.remove('open');
              const c = m.querySelector('.mega-menu__content');
              if (c) c.style.display = 'none';
            }
          });
          
          // Open this menu
          menu.classList.add('open');
          content.style.display = 'block';
        }
      });
    }
  });

  let closeOnScrollRaf = null;
  window.addEventListener(
    'scroll',
    () => {
      if (closeOnScrollRaf) return;
      closeOnScrollRaf = window.requestAnimationFrame(() => {
        closeOnScrollRaf = null;
        megaMenus.forEach(menu => {
          if (!menu.classList.contains('open')) return;
          menu.classList.remove('open');
          const content = menu.querySelector('.mega-menu__content');
          if (content) content.style.display = 'none';
        });
      });
    },
    { passive: true }
  );
}

const trapFocusHandlers = {};

function trapFocus(e, t = e) {
    var i = getFocusableElements(e);
    var s = i[0];
    var n = i[i.length - 1];
    removeTrapFocus();
    trapFocusHandlers.focusin = t => {
        if (t.target !== e && t.target !== n && t.target !== s) return;
        document.addEventListener("keydown", trapFocusHandlers.keydown)
    };
    trapFocusHandlers.focusout = function () {
        document.removeEventListener("keydown", trapFocusHandlers.keydown)
    };
    trapFocusHandlers.keydown = function (t) {
        if (t.code.toUpperCase() !== "TAB") return;
        if (t.target === n && !t.shiftKey) {
            t.preventDefault();
            s.focus()
        }
        if ((t.target === e || t.target === s) && t.shiftKey) {
            t.preventDefault();
            n.focus()
        }
    };
    document.addEventListener("focusout", trapFocusHandlers.focusout);
    document.addEventListener("focusin", trapFocusHandlers.focusin);
    t.focus();
    if (t.tagName === "INPUT" && ["search", "text", "email", "url"].includes(t.type) && t.value) {
        t.setSelectionRange(0, t.value.length)
    }
}

try {
    document.querySelector(":focus-visible")
} catch (e) {
    focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
    const e = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"];
    let t = null;
    let i = null;
    window.addEventListener("keydown", (t => {
        if (e.includes(t.code.toUpperCase())) {
            i = false
        }
    }));
    window.addEventListener("mousedown", (e => {
        i = true
    }));
    window.addEventListener("focus", (() => {
        if (t) t.classList.remove("focused");
        if (i) return;
        t = document.activeElement;
        t.classList.add("focused")
    }), true)
}

function pauseAllMedia() {
    document.querySelectorAll(".js-youtube").forEach((e => {
        e.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*")
    }));
    document.querySelectorAll(".js-vimeo").forEach((e => {
        e.contentWindow.postMessage('{"method":"pause"}', "*")
    }));
    document.querySelectorAll("video").forEach((e => e.pause()));
    document.querySelectorAll("product-model").forEach((e => {
        if (e.modelViewerUI) e.modelViewerUI.pause()
    }))
}

function removeTrapFocus(e = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin);
    document.removeEventListener("focusout", trapFocusHandlers.focusout);
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
    if (e) e.focus()
}

function onKeyUpEscape(e) {
    if (e.code?.toUpperCase() !== "ESCAPE") return;
    const t = e.target.closest("details[open]");
    if (!t) return;
    const i = t.querySelector("summary");
    t.removeAttribute("open");
    i.setAttribute("aria-expanded", false);
    i.focus()
}

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector("input");
        this.changeEvent = new Event("change", {bubbles: true});
        this.input.addEventListener("change", this.onInputChange.bind(this));
        this.querySelectorAll("button").forEach((e => e.addEventListener("click", this.onButtonClick.bind(this))))
    }

    quantityUpdateUnsubscriber = undefined;

    connectedCallback() {
        this.validateQtyRules();
        this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this))
    }

    disconnectedCallback() {
        if (this.quantityUpdateUnsubscriber) {
            this.quantityUpdateUnsubscriber()
        }
    }

    onInputChange(e) {
        this.validateQtyRules()
    }

    onButtonClick(e) {
        e.preventDefault();
        const t = this.input.value;
        e.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
        if (t !== this.input.value) this.input.dispatchEvent(this.changeEvent)
    }

    validateQtyRules() {
        const e = parseInt(this.input.value);
        if (this.input.min) {
            const t = parseInt(this.input.min);
            const i = this.querySelector(".quantity__button[name='minus']");
            i.classList.toggle("disabled", e <= t)
        }
        if (this.input.max) {
            const t = parseInt(this.input.max);
            const i = this.querySelector(".quantity__button[name='plus']");
            i.classList.toggle("disabled", e >= t)
        }
    }
}

customElements.define("quantity-input", QuantityInput);

function debounce(e, t) {
    let i;
    return (...s) => {
        clearTimeout(i);
        i = setTimeout((() => e.apply(this, s)), t)
    }
}

function fetchConfig(e = "json") {
    return {method: "POST", headers: {"Content-Type": "application/json", Accept: `application/${e}`}}
}

if (typeof window.Shopify == "undefined") {
    window.Shopify = {}
}
Shopify.bind = function (e, t) {
    return function () {
        return e.apply(t, arguments)
    }
};
Shopify.setSelectorByValue = function (e, t) {
    for (var i = 0, s = e.options.length; i < s; i++) {
        var n = e.options[i];
        if (t == n.value || t == n.innerHTML) {
            e.selectedIndex = i;
            return i
        }
    }
};
Shopify.addListener = function (e, t, i) {
    e.addEventListener ? e.addEventListener(t, i, false) : e.attachEvent("on" + t, i)
};
Shopify.postLink = function (e, t) {
    t = t || {};
    var i = t["method"] || "post";
    var s = t["parameters"] || {};
    var n = document.createElement("form");
    n.setAttribute("method", i);
    n.setAttribute("action", e);
    for (var r in s) {
        var o = document.createElement("input");
        o.setAttribute("type", "hidden");
        o.setAttribute("name", r);
        o.setAttribute("value", s[r]);
        n.appendChild(o)
    }
    document.body.appendChild(n);
    n.submit();
    document.body.removeChild(n)
};
Shopify.CountryProvinceSelector = function (e, t, i) {
    this.countryEl = document.getElementById(e);
    this.provinceEl = document.getElementById(t);
    this.provinceContainer = document.getElementById(i["hideElement"] || t);
    Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));
    this.initCountry();
    this.initProvince()
};
Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        var e = this.countryEl.getAttribute("data-default");
        Shopify.setSelectorByValue(this.countryEl, e);
        this.countryHandler()
    }, initProvince: function () {
        var e = this.provinceEl.getAttribute("data-default");
        if (e && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, e)
        }
    }, countryHandler: function (e) {
        var t = this.countryEl.options[this.countryEl.selectedIndex];
        var i = t.getAttribute("data-provinces");
        var s = JSON.parse(i);
        this.clearOptions(this.provinceEl);
        if (s && s.length == 0) {
            this.provinceContainer.style.display = "none"
        } else {
            for (var n = 0; n < s.length; n++) {
                var t = document.createElement("option");
                t.value = s[n][0];
                t.innerHTML = s[n][1];
                this.provinceEl.appendChild(t)
            }
            this.provinceContainer.style.display = ""
        }
    }, clearOptions: function (e) {
        while (e.firstChild) {
            e.removeChild(e.firstChild)
        }
    }, setOptions: function (e, t) {
        for (var i = 0, s = t.length; i < t.length; i++) {
            var n = document.createElement("option");
            n.value = t[i];
            n.innerHTML = t[i];
            e.appendChild(n)
        }
    }
};

class MenuDrawer extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector("details");
        this.addEventListener("keyup", this.onKeyUp.bind(this));
        this.addEventListener("focusout", this.onFocusOut.bind(this));
        this.bindEvents()
    }

    bindEvents() {
        this.querySelectorAll("summary").forEach((e => e.addEventListener("click", this.onSummaryClick.bind(this))));
        this.querySelectorAll("button").forEach((e => e.addEventListener("click", this.onCloseButtonClick.bind(this))))
    }

    onKeyUp(e) {
        if (e.code?.toUpperCase() !== "ESCAPE") return;
        const t = e.target.closest("details[open]");
        if (!t) return;
        t === this.mainDetailsToggle ? this.closeMenuDrawer(e, this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(t)
    }

    onSummaryClick(e) {
        const t = e.currentTarget;
        const i = t.parentNode;
        const s = i.closest(".has-submenu");
        const n = i.hasAttribute("open");
        const r = window.matchMedia("(prefers-reduced-motion: reduce)");

        function o() {
            const e = i.querySelector("button");
            if (e) {
                trapFocus(t.nextElementSibling, i.querySelector("button"));
                t.nextElementSibling.removeEventListener("transitionend", o)
            }
        }

        if (i === this.mainDetailsToggle) {
            if (n) e.preventDefault();
            n ? this.closeMenuDrawer(e, t) : this.openMenuDrawer(t);
            if (window.matchMedia("(max-width: 990px)")) {
                document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`)
            }
        } else {
            if (e.target.closest(".menu-drawer__menu-item")) {
                this.headerWhileMenuOpen()
            }
            setTimeout((() => {
                i.classList.add("menu-opening");
                t.setAttribute("aria-expanded", true);
                s && s.classList.add("submenu-open");
                !r || r.matches ? o() : t.nextElementSibling.addEventListener("transitionend", o)
            }), 100)
        }
    }

    openMenuDrawer(e) {
        setTimeout((() => {
            this.mainDetailsToggle.classList.add("menu-opening")
        }));
        e.setAttribute("aria-expanded", true);
        trapFocus(this.mainDetailsToggle, e);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
    }

    closeMenuDrawer(e, t = false) {
        if (e === undefined) return;
        this.mainDetailsToggle.classList.remove("menu-opening");
        this.mainDetailsToggle.querySelectorAll("details").forEach((e => {
            e.removeAttribute("open");
            e.classList.remove("menu-opening")
        }));
        this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((e => {
            e.classList.remove("submenu-open")
        }));
        document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
        removeTrapFocus(t);
        this.closeAnimation(this.mainDetailsToggle);
        this.restoreHeader()
    }

    onFocusOut(e) {
        setTimeout((() => {
            if (this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer()
        }))
    }

    onCloseButtonClick(e) {
        const t = e.target;
        if (t.classList.contains("localization-form__select")) return;
        const i = e.currentTarget.closest("details");
        this.closeSubmenu(i);
        const s = e.target.closest(".menu-drawer__close-button");
        if (s && s.dataset.menuDepth == "1") {
            this.restoreHeader()
        }
    }

    closeSubmenu(e) {
        const t = e.closest(".submenu-open");
        t && t.classList.remove("submenu-open");
        e.classList.remove("menu-opening");
        e.querySelector("summary").setAttribute("aria-expanded", false);
        removeTrapFocus(e.querySelector("summary"));
        this.closeAnimation(e)
    }

    closeAnimation(e) {
        let t;
        const i = s => {
            if (t === undefined) {
                t = s
            }
            const n = s - t;
            if (n < 400) {
                window.requestAnimationFrame(i)
            } else {
                e.removeAttribute("open");
                if (e.closest("details[open]")) {
                    trapFocus(e.closest("details[open]"), e.querySelector("summary"))
                }
            }
        };
        window.requestAnimationFrame(i)
    }

    headerWhileMenuOpen() {
        document.body.classList.add("drawer-submenu-open")
    }

    restoreHeader() {
        document.body.classList.remove("drawer-submenu-open")
    }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super()
    }

    openMenuDrawer(e) {
        this.header = this.header || document.querySelector(".section-header");
        this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;
        document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().top - this.borderOffset)}px`);
        this.header.classList.add("menu-open");
        this.searchNav = this.header.querySelector(".menu-drawer__search-container");
        if (this.searchNav) {
            window.requestAnimationFrame((() => {
                document.documentElement.style.setProperty("--menu-search-height", `${this.searchNav.scrollHeight}px`)
            }))
        }
        this.announcementBar = document.querySelector(".announcement-bar-section");
        if (this.announcementBar) {
            window.requestAnimationFrame((() => {
                document.documentElement.style.setProperty("--announcement-bar-height", `${this.announcementBar.scrollHeight}px`)
            }))
        }
        setTimeout((() => {
            this.mainDetailsToggle.classList.add("menu-opening")
        }));
        e.setAttribute("aria-expanded", true);
        trapFocus(this.mainDetailsToggle, e);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
    }

    closeMenuDrawer(e, t) {
        super.closeMenuDrawer(e, t);
        this.header.classList.remove("menu-open")
    }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
    constructor() {
        super();
        this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, false));
        this.addEventListener("keyup", (e => {
            if (e.code.toUpperCase() === "ESCAPE") this.hide()
        }));
        if (!this.classList.contains("media-modal")) {
            this.addEventListener("click", (e => {
                if (e.target === this) this.hide()
            }))
        }
    }

    connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this)
    }

    show(e) {
        this.openedBy = e;
        const t = this.querySelector(".template-popup");
        document.body.classList.add("overflow-hidden");
        this.setAttribute("open", "");
        if (t) t.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia()
    }

    hide() {
        if (!this.classList.contains("product-popup-modal")) {
            document.body.classList.remove("overflow-hidden")
        }
        document.body.dispatchEvent(new CustomEvent("modalClosed"));
        this.removeAttribute("open");
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia()
    }
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
    constructor() {
        super();
        const e = this.querySelector("button");
        if (!e) return;
        e.addEventListener("click", (() => {
            const t = document.querySelector(this.getAttribute("data-modal"));
            if (t) t.show(e)
        }))
    }
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const e = this.querySelector('[id^="Deferred-Poster-"]');
        if (!e) return;
        e.addEventListener("click", this.loadContent.bind(this))
    }

    loadContent(e = true) {
        window.pauseAllMedia();
        if (!this.getAttribute("loaded")) {
            const t = document.createElement("div");
            t.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));
            this.setAttribute("loaded", true);
            const i = this.appendChild(t.querySelector("video, model-viewer, iframe"));
            if (e) i.focus()
        }
    }
}

customElements.define("deferred-media", DeferredMedia);

class ResponsiveDeferredMedia extends DeferredMedia {
    constructor() {
        super();
        this.pauseWhenOutsideViewport()
    }

    pauseVideos() {
        var e = this.querySelector("iframe, video");
        if (e) {
            if (e.tagName.toLowerCase() === "video") {
                e.pause()
            }
            if (e.tagName.toLowerCase() === "iframe") {
                e.contentWindow.postMessage(JSON.stringify({event: "command", func: "pauseVideo"}), "*")
            }
        }
    }

    pauseWhenOutsideViewport() {
        let e = {root: null, rootMargin: "0px", threshold: .1};
        let t = (e, t) => {
            e.forEach((e => {
                if (!e.isIntersecting) {
                    this.pauseVideos()
                }
            }))
        };
        let i = new IntersectionObserver(t, e);
        i.observe(this)
    }
}

customElements.define("responsive-deferred-media", ResponsiveDeferredMedia);

class SliderComponent extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector('[id^="Slider-"]');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.sliderPagersWrapper = this.querySelector(".slider-pagers");
        this.sliderPagers = this.querySelectorAll("[data-slide-pager]");
        this.enableSliderLooping = false;
        this.currentPageElement = this.querySelector(".slider-counter--current");
        this.pageTotalElement = this.querySelector(".slider-counter--total");
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');
        this.isDown = false;
        this.startX;
        this.scrollLeft;
        this.slider.addEventListener("mousedown", (e => {
            this.isDown = true;
            this.startX = e.pageX - this.slider.offsetLeft;
            this.scrollLeft = this.slider.scrollLeft
        }));
        this.slider.addEventListener("mouseup", (() => {
            this.isDown = false
        }));
        this.slider.addEventListener("mouseleave", (() => {
            this.isDown = false
        }));
        this.slider.addEventListener("mousemove", (e => {
            if (!this.isDown) return;
            e.preventDefault();
            const t = e.pageX - this.slider.offsetLeft;
            const i = (t - this.startX) * 2;
            this.slider.scrollLeft = this.scrollLeft - i
        }));
        if (this.sliderPagers && this.sliderPagers.length > 0) {
            this.initPagers()
        }
        if (!this.slider || !this.nextButton) return;
        this.initPages();
        const e = new ResizeObserver((e => this.initPages()));
        e.observe(this.slider);
        this.slider.addEventListener("scroll", this.update.bind(this));
        this.slider.addEventListener("scroll", this.fetchLazyImagesOnScroll.bind(this));
        this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
        this.nextButton.addEventListener("click", this.onButtonClick.bind(this))
    }

    fetchLazyImagesOnScroll() {
        requestAnimationFrame((() => {
            const e = this.slider.querySelectorAll('img[loading="lazy"]');
            e.forEach((e => {
                e.removeAttribute("loading");
                e.src = e.getAttribute("src")
            }))
        }))
    }

    initPagers() {
        this.sliderPagers.forEach(((e, t) => {
            e.addEventListener("click", (() => {
                const e = this.slider.children[t];
                this.slider.scroll({left: e.offsetLeft, behavior: "smooth"})
            }))
        }));
        this.slider.addEventListener("scroll", (() => {
            const e = this.slider.scrollLeft;
            this.sliderItems.forEach(((t, i) => {
                const s = this.sliderPagersWrapper.children[i];
                if (e >= t.offsetLeft && e < t.offsetLeft + t.offsetWidth) {
                    s.classList.add("is-current")
                } else {
                    s.classList.remove("is-current")
                }
            }))
        }))
    }

    initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter((e => e.clientWidth > 0));
        if (this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        this.update()
    }

    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.initPages()
    }

    update() {
        if (!this.slider || !this.nextButton) return;
        const e = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
        if (this.currentPageElement && this.pageTotalElement) {
            this.currentPageElement.textContent = this.currentPage;
            this.pageTotalElement.textContent = this.totalPages
        }
        if (this.currentPage != e) {
            this.dispatchEvent(new CustomEvent("slideChanged", {
                detail: {
                    currentPage: this.currentPage,
                    currentElement: this.sliderItemsToShow[this.currentPage - 1]
                }
            }))
        }
        if (this.enableSliderLooping) return;
        if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
            this.prevButton.setAttribute("disabled", "disabled")
        } else {
            this.prevButton.removeAttribute("disabled")
        }
        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
            this.nextButton.setAttribute("disabled", "disabled")
        } else {
            this.nextButton.removeAttribute("disabled")
        }
    }

    isSlideVisible(e, t = 0) {
        const i = this.slider.clientWidth + this.slider.scrollLeft - t;
        return e.offsetLeft + e.clientWidth <= i && e.offsetLeft >= this.slider.scrollLeft
    }

    onButtonClick(e) {
        e.preventDefault();
        const t = e.currentTarget.dataset.step || 1;
        this.slideScrollPosition = e.currentTarget.name === "next" ? this.slider.scrollLeft + t * this.sliderItemOffset : this.slider.scrollLeft - t * this.sliderItemOffset;
        this.slider.scrollTo({left: this.slideScrollPosition})
    }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
    constructor() {
        super();
        this.sliderControlWrapper = this.querySelector(".slider-buttons");
        this.enableSliderLooping = true;
        if (!this.sliderControlWrapper) return;
        this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
        if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
        this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link"));
        this.sliderControlLinksArray.forEach((e => e.addEventListener("click", this.linkToSlide.bind(this))));
        this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
        this.setSlideVisibility();
        if (this.slider.getAttribute("data-autoplay") === "true") this.setAutoPlay()
    }

    setAutoPlay() {
        this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
        this.autoplaySpeed = this.slider.dataset.speed * 1e3;
        this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this));
        this.addEventListener("mouseover", this.focusInHandling.bind(this));
        this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
        this.addEventListener("focusin", this.focusInHandling.bind(this));
        this.addEventListener("focusout", this.focusOutHandling.bind(this));
        this.play();
        this.autoplayButtonIsSetToPlay = true
    }

    onButtonClick(e) {
        super.onButtonClick(e);
        const t = this.currentPage === 1;
        const i = this.currentPage === this.sliderItemsToShow.length;
        if (!t && !i) return;
        if (t && e.currentTarget.name === "previous") {
            this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length
        } else if (i && e.currentTarget.name === "next") {
            this.slideScrollPosition = 0
        }
        this.slider.scrollTo({left: this.slideScrollPosition})
    }

    update() {
        super.update();
        this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
        this.prevButton.removeAttribute("disabled");
        if (!this.sliderControlButtons.length) return;
        this.sliderControlButtons.forEach((e => {
            e.classList.remove("slider-counter__link--active");
            e.removeAttribute("aria-current")
        }));
        this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active");
        this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", true)
    }

    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
        this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
        this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay
    }

    focusOutHandling(e) {
        const t = e.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(e.target);
        if (!this.autoplayButtonIsSetToPlay || t) return;
        this.play()
    }

    focusInHandling(e) {
        const t = e.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(e.target);
        if (t && this.autoplayButtonIsSetToPlay) {
            this.play()
        } else if (this.autoplayButtonIsSetToPlay) {
            this.pause()
        }
    }

    play() {
        this.slider.setAttribute("aria-live", "off");
        clearInterval(this.autoplay);
        this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed)
    }

    pause() {
        this.slider.setAttribute("aria-live", "polite");
        clearInterval(this.autoplay)
    }

    togglePlayButtonState(e) {
        if (e) {
            this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
            this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow)
        } else {
            this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
            this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow)
        }
    }

    autoRotateSlides() {
        const e = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector(".slideshow__slide").clientWidth;
        this.slider.scrollTo({left: e})
    }

    setSlideVisibility() {
        this.sliderItemsToShow.forEach(((e, t) => {
            const i = e.querySelectorAll("a");
            if (t === this.currentPage - 1) {
                if (i.length) i.forEach((e => {
                    e.removeAttribute("tabindex")
                }));
                e.setAttribute("aria-hidden", "false");
                e.removeAttribute("tabindex")
            } else {
                if (i.length) i.forEach((e => {
                    e.setAttribute("tabindex", "-1")
                }));
                e.setAttribute("aria-hidden", "true");
                e.setAttribute("tabindex", "-1")
            }
        }))
    }

    linkToSlide(e) {
        e.preventDefault();
        const t = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(e.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({left: t})
    }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.siblingInstances = [...document.querySelectorAll(this.nodeName)].filter((e => e.id !== this.id));
        this.addEventListener("change", this.onVariantChange);
        this.availabilityString = window.variantStrings.available;
        this.init()
    }

    init() {
        // Disabled: No auto-selection from URL variant parameter
        // this.setVariantFromURL()
    }

    setVariantFromURL() {
        // Disabled: Prevent auto-selection of variant from URL
        // const e = new Proxy(new URLSearchParams(window.location.search), {get: (e, t) => e.get(t)});
        // const t = e.variant;
        // if (!t) return;
        // this.updateOptions();
        // this.updateMasterId(t);
        // this.updateSelectLabel()
        return;
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, "", false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantStatuses();
        this.updateSelectLabel();
        if (!this.currentVariant) {
            this.toggleAddButton(true, "", true);
            this.setUnavailable();
            this.updateSelectLabel()
        } else {
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
            this.toggleNotifyButton()
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll("select"), (e => e?.value))
    }

    updateMasterId(e) {
        const t = this.getVariantData();
        if (e) {
            this.currentVariant = t.find((t => t.id == e));
            return
        }
        this.currentVariant = t.find((e => !e.options.map(((e, t) => this.options[t] === e)).includes(false)))
    }

    updateSelectLabel() {
        if (!this.currentVariant) {
            this.currentVariant = this.getVariantData().find((e => !e.options.map(((e, t) => this.options[t] === e)).includes(false)))
        }
        const e = this.getSizeOptionPosition();
        let t = this.currentVariant.option1;
        if (e === 2) {
            t = this.currentVariant.option2
        }
        let i = "";
        const s = document.querySelector("#inventory-wrapper");
        if (!s) return;
        this.inventoryThreshold = parseInt(s.dataset.inventoryThreshold);
        this.showInventoryQuantity = s.dataset.showInventoryQuantity === "true";
        this.showOnlyOnLowStock = s.dataset.showOnlyOnLowStock === "true";
        this.showInVariantPicker = s.dataset.showInVariantPicker === "true";
        if (!this.currentVariant.available) {
            this.availabilityString = window.variantStrings.soldOut;
            i = "out-of-stock"
        } else if (this.currentVariant.inventory_quantity > this.inventoryThreshold) {
            this.availabilityString = this.showInventoryQuantity ? `${this.currentVariant.inventory_quantity} in stock` : window.variantStrings.available;
            i = "in-stock"
        } else {
            this.availabilityString = `${window.variantStrings.limitedStock}: ${this.currentVariant.inventory_quantity} left`;
            i = "low-stock"
        }
        const n = `\n      <svg width="15" height="15" aria-hidden="true" class="stock-indicator ${i}">\n        <circle cx="7.5" cy="7.5" r="7.5" fill="currentColor" opacity="0.3"></circle>\n        <circle cx="7.5" cy="7.5" r="5" stroke="rgb(255, 255, 255)" stroke-width="1" fill="currentColor"></circle>\n      </svg>\n    `;
        const r = document.querySelectorAll(".product__option-accordion-title");
        r.forEach((e => {
            if (this.showOnlyOnLowStock && this.currentVariant.inventory_quantity > this.inventoryThreshold) {
                e.classList.add("visibility-hidden")
            } else {
                e.classList.remove("visibility-hidden")
            }
            e.innerHTML = n + `<span class="availability-string"> ${this.availabilityString}</span>`
        }));
        document.dispatchEvent(new CustomEvent("VariantSelects.updateSelectLabel"))
    }

    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;
        const e = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
        e.forEach((e => e.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)));
        const t = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        if (!t) return;
        const i = t.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        t.prepend(i)
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;
        window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`)
    }

    updateShareUrl() {
        const e = document.getElementById(`Share-${this.dataset.section}`);
        if (!e || !e.updateUrl) return;
        e.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`)
    }

    updateVariantInput() {
        const e = document.querySelectorAll(`form#product-form-${this.dataset.section}, form#product-form-installment-${this.dataset.section}, form#bottom-bar-hidden-form, .product-form > form.form`);
        e.forEach((e => {
            const t = e.querySelector('input[name="id"]');
            t.value = this.currentVariant.id;
            t.dispatchEvent(new Event("change", {bubbles: true}))
        }))
    }

    updateVariantStatuses() {
        const e = this.variantData.filter((e => this.querySelector(":checked").value === e.option1));
        const t = [...this.querySelectorAll(".product-form__input")];
        t.forEach(((i, s) => {
            if (s === 0) return;
            const n = [...i.querySelectorAll('input[type="radio"], option')];
            const r = t[s - 1].querySelector(":checked").value;
            const o = e.filter((e => e.available && e[`option${s}`] === r)).map((e => e[`option${s + 1}`]));
            this.setInputAvailability(n, o)
        }))
    }

    setInputAvailability(e, t) {
        e.forEach((e => {
            if (t.includes(e.getAttribute("value"))) {
                e.innerText = e.getAttribute("value")
            } else {
                e.innerText = window.variantStrings.unavailable_with_option.replace("[value]", e.getAttribute("value"))
            }
        }))
    }

    updatePickupAvailability() {
        const e = document.querySelector("pickup-availability");
        if (!e) return;
        if (this.currentVariant && this.currentVariant.available) {
            e.fetchAvailability(this.currentVariant.id)
        } else {
            e.removeAttribute("available");
            e.innerHTML = ""
        }
    }

    removeErrorMessage() {
        const e = this.closest("section");
        if (!e) return;
        const t = e.querySelector("product-form");
        if (t) t.handleErrorMessage()
    }

    renderProductInfo() {
        const e = this.currentVariant.id;
        const t = document.querySelector(".product__info-container");
        let i = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        if (this.classList.contains("is-bottom-bar")) {
            i = t.dataset.section
        }
        fetch(`${this.dataset.url}?variant=${e}`).then((e => e.text())).then((s => {
            if (this.currentVariant.id !== e) return;
            let n = this;
            if (this.classList.contains("is-bottom-bar")) {
                n = t.querySelector(".variant-selector")
            }
            const r = (new DOMParser).parseFromString(s, "text/html");
            const o = document.getElementById(`title-${i}`);
            const a = r.getElementById(`title-${i}`);
            const l = document.getElementById(`price-${i}`);
            const d = r.getElementById(`price-${i}`);
            const c = r.getElementById(`Sku-${i}`);
            const u = document.getElementById(`Sku-${i}`);
            const h = r.getElementById(`Inventory-${i}`);
            const p = document.getElementById(`Inventory-${i}`);
            if (a && o) o.innerHTML = a.innerHTML;
            if (d && l) l.innerHTML = d.innerHTML;
            if (h && p) p.innerHTML = h.innerHTML;
            if (c && u) {
                u.innerHTML = c.innerHTML;
                u.classList.toggle("visibility-hidden", c.classList.contains("visibility-hidden"))
            }
            const m = document.getElementById(`price-${i}`);
            if (m) m.classList.remove("visibility-hidden");
            if (p) p.classList.toggle("visibility-hidden", h.innerText === "");
            const f = r.getElementById(`ProductSubmitButton-${i}`);
            publish(PUB_SUB_EVENTS.variantChange, {data: {sectionId: i, html: r, variant: this.currentVariant}})
        }))
    }

    toggleAddButton(e = true, t, i = true) {
        const s = document.querySelector("form.installment");
        if (!s) return;
        const n = document.querySelectorAll('button[name="add"]');
        const r = document.querySelectorAll(".sticky-btn-anchor");
        if (!n?.length) return;
        n.forEach((e => e.classList.remove("button--hover-text")));
        if (e) {
            n.forEach((e => {
                e.setAttribute("aria-disabled", true);
                e.classList.add("loading");
                e.querySelector(".loading-overlay__spinner").classList.remove("hidden");
                e.disabled = true
            }));
            r.forEach((e => e.classList.add("is-visible")));
            if (t) {
                n.forEach((e => {
                    const i = e.querySelector("span");
                    if (!i) return;
                    i.textContent = t;
                    e.classList.remove("loading");
                    e.querySelector(".loading-overlay__spinner").classList.add("hidden")
                }))
            }
        } else {
            n.forEach((e => {
                e.setAttribute("aria-disabled", false);
                e.classList.remove("loading");
                e.querySelector(".loading-overlay__spinner").classList.add("hidden");
                e.disabled = false;
                const t = e.querySelector("span");
                if (!t) return;
                t.textContent = window.variantStrings.addToCart
            }));
            r.forEach((e => e.classList.remove("is-visible")))
        }
        if (!i) return
    }

    toggleNotifyButton() {
        const e = document.querySelectorAll(".button--notify");
        const t = document.querySelectorAll('button[name="add"]');
        if (this.currentVariant.available) {
            e.forEach((e => e.classList.add("is-hidden")));
            t.forEach((e => e.classList.remove("is-hidden")))
        } else {
            e.forEach((e => e.classList.remove("is-hidden")));
            t.forEach((e => e.classList.add("is-hidden")))
        }
    }

    setUnavailable() {
        const e = document.getElementById(`product-form-${this.dataset.section}`);
        const t = e.querySelector('[name="add"]');
        const i = e.querySelector('[name="add"] > span');
        const s = document.getElementById(`price-${this.dataset.section}`);
        const n = document.getElementById(`Inventory-${this.dataset.section}`);
        const r = document.getElementById(`Sku-${this.dataset.section}`);
        if (!t) return;
        i.textContent = window.variantStrings.unavailable;
        if (s) s.classList.add("visibility-hidden");
        if (n) n.classList.add("visibility-hidden");
        if (r) r.classList.add("visibility-hidden")
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector("[data-product-variants]").textContent);
        return this.variantData
    }

    getSizeOptionPosition() {
        const e = this.querySelector("[data-product-options]");
        if (!e) return;
        const t = JSON.parse(e.textContent);
        const i = t.findIndex((e => e.toLowerCase() === "size"));
        if (i >= 0) {
            return i + 1
        }
    }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
        this.addEventListener("change", this.updateSiblingInputStates)
    }

    setInputAvailability(e, t) {
        e.forEach((e => {
            if (t.includes(e.getAttribute("value"))) {
                e.classList.remove("disabled")
            } else {
                e.classList.add("disabled")
            }
        }))
    }

    updateOptions() {
        const e = Array.from(this.querySelectorAll("fieldset"));
        this.options = e.map((e => {
            const t = e.querySelectorAll("input");
            return Array.from(t).find((e => e.checked))?.value
        }))
    }

    updateSiblingInputStates(e) {
        this.siblingInstances.forEach((e => e.currentVariant = this.currentVariant));
        const t = [...this.siblingInstances.map((t => [...t.querySelectorAll(`${e.target.nodeName}`)]))];
        t.forEach((t => {
            const i = t.find((t => t.value === e.target.value));
            if (!i) return;
            i.checked = true
        }));
        this.renderProductInfoBottomBar()
    }

    renderProductInfoBottomBar() {
        const e = this.currentVariant.id;
        const t = "bottom-bar-section";
        fetch(`${this.dataset.url}?variant=${e}`).then((e => e.text())).then((i => {
            if (this.currentVariant.id !== e) return;
            const s = (new DOMParser).parseFromString(i, "text/html");
            const n = document.getElementById(`price-${this.dataset.productId}`);
            const r = s.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.productId}`);
            if (r && n) n.innerHTML = r.innerHTML;
            const o = document.getElementById(`price-${this.dataset.section}`);
            if (o) o.classList.remove("visibility-hidden");
            this.toggleAddButton(this.availabilityString === window.variantStrings.soldOut ? true : false, this.availabilityString);
            publish(PUB_SUB_EVENTS.variantChange, {data: {sectionId: t, html: s, variant: this.currentVariant}})
        }))
    }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        const e = (e, t) => {
            if (!e[0].isIntersecting) return;
            t.unobserve(this);
            fetch(this.dataset.url).then((e => e.text())).then((e => {
                const t = document.createElement("div");
                t.innerHTML = e;
                const i = t.querySelector("product-recommendations");
                if (i && i.innerHTML.trim().length) {
                    this.innerHTML = i.innerHTML
                }
                if (!this.querySelector("slideshow-component") && this.classList.contains("complementary-products")) {
                    this.remove()
                }
                if (t.querySelector(".grid__item")) {
                    this.classList.add("product-recommendations--loaded")
                }
                window.checkWishlistStatusOnElements(".iWishAddColl")
            })).catch((e => {
                console.error(e)
            }))
        };
        new IntersectionObserver(e.bind(this), {rootMargin: "0px 0px 400px 0px"}).observe(this)
    }
}

customElements.define("product-recommendations", ProductRecommendations);

class VideoSection extends HTMLElement {
    constructor() {
        super();
        this.elements = {video: this.querySelector("video"), button: this.querySelector("[data-play-pause]")};
        if (this.classList.contains("has-responsive-videos")) {
            this.elements = {
                landscapeVideo: this.querySelector(".landscape-video video"),
                portraitVideo: this.querySelector(".portrait-video video"),
                button: this.querySelector("[data-play-pause]")
            };
            this.handleResize = this.handleResize.bind(this);
            window.addEventListener("resize", this.handleResize);
            this.handleResize()
        }
        if (this.elements.button) {
            this.elements.button.addEventListener("click", this.playVideo.bind(this))
        }
        if (this.hasResponsiveVideos()) {
            [this.elements.landscapeVideo, this.elements.portraitVideo].forEach((e => {
                if (e) {
                    e.addEventListener("click", this.togglePlayPause.bind(this));
                    e.addEventListener("play", this.videoIsPlaying.bind(this));
                    e.addEventListener("pause", this.videoIsPaused.bind(this))
                }
            }))
        } else if (this.elements.video) {
            this.elements.video.addEventListener("click", this.togglePlayPause.bind(this));
            this.elements.video.addEventListener("play", this.videoIsPlaying.bind(this));
            this.elements.video.addEventListener("pause", this.videoIsPaused.bind(this))
        }
    }

    hasResponsiveVideos() {
        return this.classList.contains("has-responsive-videos")
    }

    handleResize() {
        if (!this.hasResponsiveVideos()) return;
        const e = window.innerWidth >= 990;
        if (this.elements.landscapeVideo && this.elements.portraitVideo) {
            this.elements.landscapeVideo.pause();
            this.elements.portraitVideo.pause();
            this.videoIsPaused();
            this.currentVideo = e ? this.elements.landscapeVideo : this.elements.portraitVideo
        }
    }

    playVideo() {
        if (this.hasResponsiveVideos()) {
            if (this.currentVideo) {
                this.currentVideo.play()
            }
        } else {
            if (this.elements.video) {
                this.elements.video.play()
            }
        }
    }

    pauseVideo() {
        if (this.hasResponsiveVideos()) {
            if (this.currentVideo) {
                this.currentVideo.pause()
            }
        } else {
            if (this.elements.video) {
                this.elements.video.pause()
            }
        }
    }

    videoIsPlaying() {
        if (this.hasResponsiveVideos()) {
            if (this.currentVideo) {
                this.currentVideo.controls = false
            }
        } else {
            if (this.elements.video) {
                this.elements.video.controls = false
            }
        }
        this.classList.add("video-is-playing")
    }

    videoIsPaused() {
        if (this.hasResponsiveVideos()) {
            if (this.currentVideo) {
                this.currentVideo.controls = false
            }
        } else {
            if (this.elements.video) {
                this.elements.video.controls = false
            }
        }
        this.classList.remove("video-is-playing")
    }

    togglePlayPause() {
        if (this.hasResponsiveVideos()) {
            if (this.currentVideo) {
                if (this.currentVideo.paused) {
                    this.playVideo()
                } else {
                    this.pauseVideo()
                }
            }
        } else {
            if (this.elements.video) {
                if (this.elements.video.paused) {
                    this.playVideo()
                } else {
                    this.pauseVideo()
                }
            }
        }
    }

    disconnectedCallback() {
        if (this.hasResponsiveVideos()) {
            window.removeEventListener("resize", this.handleResize)
        }
        this.elements.video.controls = false;
        this.classList.remove("video-is-playing")
    }
}

class ResponsiveVideoSection extends VideoSection {
    constructor() {
        super();
        this.pauseWhenOutsideViewport()
    }

    pauseWhenOutsideViewport() {
        let e = {root: null, rootMargin: "0px", threshold: .1};
        let t = (e, t) => {
            e.forEach((e => {
                if (!e.isIntersecting) {
                    this.pauseVideo()
                } else {
                    if (this.elements.video.loop = true) this.playVideo()
                }
            }))
        };
        let i = new IntersectionObserver(t, e);
        i.observe(this.elements.video)
    }
}

customElements.define("video-file-section", VideoSection);
customElements.define("responsive-video-file-section", ResponsiveVideoSection);
document.addEventListener("click", (function (e) {
    const t = e.target.closest("a");
    if (!t || t.classList.contains("dont-scroll")) return;
    if (!t) return;
    const i = t.getAttribute("href");
    if (!i || !i.startsWith("#") || i === "#") return;
    const s = i.slice(1);
    const n = document.getElementById(s);
    if (!n) return;
    e.preventDefault();
    const r = n.closest(".accordion");
    if (r) {
        const e = r.querySelector("details");
        const t = r.querySelector("summary");
        e.setAttribute("open", "");
        t.setAttribute("aria-expanded", "true");
        if (r.classList.contains("accordion--close-others")) {
            const e = r.closest(".collapsible-content__grid");
            if (e) {
                e.querySelectorAll(".accordion").forEach((e => {
                    if (e !== r) {
                        const t = e.querySelector("details");
                        const i = e.querySelector("summary");
                        if (t && i) {
                            t.removeAttribute("open");
                            i.setAttribute("aria-expanded", "false");
                            i.parentElement.querySelector(".accordion__content")?.classList.remove("animate")
                        }
                    }
                }))
            }
        }
        setTimeout((() => {
            r.querySelector(".accordion__content")?.classList.add("animate")
        }), 10)
    }
    const o = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height"), 10);
    const a = n.getBoundingClientRect().top + window.pageYOffset - o - 20;
    window.scrollTo({top: a, behavior: "smooth"})
}));